export const RoleEnum = Object.freeze({
    STUDENT: 'student',
    INFRASTRUCTURE: 'infrastructure',
    COUNSELING: 'counseling',
    CURRICULUM: 'curriculum',
    ADMIN: 'admin',
    STAFF: 'staff',
    RECEPTIONIST: 'receptionist',
    ACCOUNTANT: 'accountant',
    STUDENTSHIP: 'studentship',
    TEACHER: 'teacher',
    PARENTS: 'parents',
    SUPER_ADMIN: 'super-admin',
    FOUNDATION: 'foundation',
    HEADMASTER: 'headmaster',
});
